import {
  Avatar,
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Divider,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React from "react";
import RecurringDonation from "./RecurringDonation";
import SpecialDonation from "./SpecialDonation";
import { blue, grey, orange } from "@mui/material/colors";
import Carousel from "react-material-ui-carousel";
import Donations from "./Donations";
import Mission from "./Mission";
import AskingDonations from "./AskingDonations";
import Contact from "./Contact";

const Homepage = () => {
  const theme = useTheme();
  const matchesSmUp = useMediaQuery(theme.breakpoints.up("sm"));

  return (
    <>
      <Box sx={{ py: 3, bgcolor: "secondary.dark" }}>
        <Box
          sx={{
            maxWidth: "850px",
            mx: "auto",
            px: 2,
          }}
        >
          <Stack direction="row" alignItems="center">
            <Avatar
              alt="try logo"
              src="/club_logos/try.jpeg"
              sx={{ width: 105, height: 105, mr: { xs: 3, sm: 6 } }}
            />
            <Box>
              <Stack direction="row" alignItems="center">
                <Typography variant="h4" sx={{ color: grey[100] }}>
                  TRY
                </Typography>
                <Button
                  href="#mission"
                  color="success"
                  variant="contained"
                  size="small"
                  sx={{ px: 2, ml: 3, py: 0.2 }}
                >
                  Our Mission
                </Button>
              </Stack>
              <Typography
                sx={{
                  fontSize: { xs: ".9rem", sm: "1.1rem" },
                  color: grey[300],
                  mt: 0.5,
                }}
              >
                Volunteer organization with an indomitable desire and mentality
                to stand beside people now working all over the country
              </Typography>
            </Box>
          </Stack>
        </Box>
      </Box>

      <Box
        sx={{
          width: { xs: "100vw", sm: "1100px" },
          mx: "auto",
          my: { xs: 0, sm: 2 },
        }}
      >
        <Carousel
          duration={300}
          stopAutoPlayOnHover={false}
          indicators={false}
          navButtonsAlwaysVisible={true}
          autoPlay={true}
          height={matchesSmUp ? 530 : 220}
          navButtonsProps={{
            style: {
              backgroundColor: orange[500],
              color: grey[50],
            },
          }}
        >
          <img
            src="banners/try_banner_1.jpg"
            width="100%"
            style={{ borderRadius: matchesSmUp ? 10 : 0 }}
          />
          <img
            src="banners/try_banner_2.jpg"
            width="100%"
            style={{ borderRadius: matchesSmUp ? 10 : 0 }}
          />
        </Carousel>
      </Box>

      <Box>
        <Donations />
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "center",
          spacing: 2,
          bgcolor: grey[50],
          py: { xs: 4, sm: 8 },
        }}
      >
        <SpecialDonation />
        <RecurringDonation />
      </Box>

      <Box>
        <AskingDonations />
      </Box>

      <Box sx={{ backgroundColor: "secondary.dark" }}>
        <Mission />
      </Box>
      <Box>
        <Contact />
      </Box>
    </>
  );
};

export default Homepage;
